import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import { Select } from '@tesla/informed-tds';
import { getCountries } from '@tesla/region';
import messages from './messages';

const Country = ({ options, ...props }) => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;

  const getCountryOptions = () => {
    let countryOptions = [
      {
        const: '',
        title: formatMessage(messages.EmptySelectOption),
      },
    ];
    if (options.length > 0) {
      countryOptions = options;
    } else {
      const langCode = locale.substring(0, 2);
      const allCountries = getCountries(null, langCode);
      allCountries.forEach((country) => {
        countryOptions.push({
          value: country.code,
          label: country.label ? country.label : country.code,
        });
      });
    }

    // Sort the options alphabetically.
    countryOptions.sort((countryA, countryB) => {
      // Ensure empty option stays on top.
      if (countryA.value === '') return -1;
      if (countryB.value === '') return 1;
      return countryA.label.localeCompare(countryB.label);
    });

    return countryOptions;
  };

  return (
    <Select {...props}>
      {getCountryOptions().map((option) => (
        <option key={`countryCode_${option.value}`} value={option.value}>
          {option.label ? option.label : option.value}
        </option>
      ))}
    </Select>
  );
};

Country.propTypes = {
  options: arrayOf(
    shape({
      const: string,
      title: string,
    })
  ),
};

Country.defaultProps = {
  options: [],
};

export default Country;
